import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../../errorhandling';
import router from '../../../router/router';

let localSubscription = undefined;

function createSubscription(store) {
	let attributeQuery = new Parse.Query('EntryTypes');
	attributeQuery.find()
		.then((results) => {
			store.dispatch('entrytypes/set', results)
		})
		.catch((error) => {
			handleParseError(error);
			
		});
	attributeQuery.subscribe().then((subscription) => {
		
		localSubscription = subscription;

		subscription.on('create', object => {
			
			store.dispatch('entrytypes/insert', object)
		});
		subscription.on('update', object => {
			
			store.dispatch('entrytypes/replace', object)
		});
		subscription.on('enter', object => {
			
			store.dispatch('entrytypes/insert', object)
		});
		subscription.on('leave', object => {
			
			store.dispatch('entrytypes/delete', object)
		});
		subscription.on('delete', object => {
			
			store.dispatch('entrytypes/delete', object)
		});
		subscription.on('close', () => {
			
		});
		subscription.on('error', error => {
			
		})
	})
}

export default function createEntryTypesSubscription() {
	return store => {
		store.subscribe(mutation => {
			//1: Check - Wird die richtige Mutation ausgelöst? Diese wird im Router bei jedem Routing-Vorgang ausgelöst.
			if (mutation.type === 'ADD_LAST_ROUTE') {
				//2: Check - Bin ich aktuell im Tagebuch?
				if (router.currentRoute.name == "Diary" || router.currentRoute.name == "EntryDetail" || 
					router.currentRoute.name == "EntryInput" || router.currentRoute.name == "EntryEdit" || router.currentRoute.name == "Notifications") {
					//3: Check - Prüfe, ob bereits eine lokale Subscription vorliegt.
					if (!localSubscription) {
						createSubscription(store)
					}
				}
			}
		})
	}
}